/**
 * Shows an error message in a Snackbar
 *
 * @param {String} message The error message to show
 * @return {Node|undefined} The Snackbar object
 */
const showError = message => {
	// Check if the message is empty
	if ( _uo.utility.isEmpty( message ) ) {
		return;
	}

	// Show Snackbar with error message
	return _uo.utility.createSnackbar( {
		message: message,
		color: 'error',
		iconID: 'times-circle-solid',
		duration: 5000
	} );
}

export default showError;
